import React, { useEffect, useState } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "./app.css";
import Loading from "./loading.js";
import { secretKey } from "./data";

const MySwal = withReactContent(Swal2);

const AddFile = (props) => {
  const [loading, setLoading] = useState(true);
  const [uploadFiles, setUploadFiles] = useState("");
  const [uploadFilesArray, setUploadFilesArray] = useState([]);
  const [uploadFilesNamesArray, setUploadFilesNamesArray] = useState([]);
  const [uploadFilesNamesArrayChanged, setUploadFilesNamesArrayChanged] =
    useState([]);
  const [inputs, setInputs] = useState({});

  const changeFiles = (e) => {
    setLoading(true);
    setUploadFiles([]);
    setUploadFilesArray([]);
    setUploadFilesNamesArray([]);

    setUploadFiles(e.target.files);
    setUploadFilesArray(Array.from(e.target.files));
    var arr = [];
    Array.from(e.target.files).map((el, index) => {
      arr.push({ id: index, name: el.name });
    });
    setUploadFilesNamesArray(arr);
    setLoading(false);
  };

  const changeFileName = (e) => {
    if (inputs[e.target.value] === "" || inputs[e.target.value] === undefined) {
      MySwal.fire({
        icon: "error",
        title: "Błąd",
        text: "Wypełnij wymagane pola formularza",
      });
    } else {
      var name = inputs[e.target.value];
      var newFile = new File(
        [uploadFilesArray[e.target.value]],
        name + "." + uploadFilesArray[e.target.value].name.split(".")[1],
        {
          type: uploadFilesArray[e.target.value].type,
        }
      );

      var arr = uploadFilesArray.filter(
        (el, index) => index !== +e.target.value
      );
      arr.push(newFile);

      setUploadFilesArray(arr);
      inputs[e.target.value] = "";
    }
  };

  const deleteTempFile = (e) => {
    var arr = uploadFilesArray.filter((el, index) => index !== +e.target.value);

    if (arr.length === 0) {
      setUploadFilesArray([]);
    } else {
      setUploadFilesArray(arr);
    }
  };

  const fetchAddFiles = async (e) => {
    if (validate()) {
      uploadFilesArray.map(async (file) => {
        let formData = new FormData();
        formData.append("file", file);
        formData.append("leadId", props.lead.id);
        formData.append("user", props.user.id);

        await fetch("https://apisplit.ftpeople.pl/addFile", {
          method: "POST",
          body: formData,
        })
          .then((response) => {
            return response.text();
          })
          .then((responseJson) => {});
      });

      MySwal.fire({
        icon: "success",
        title: "Dodano",
        text: "pliki",
      }).then((result) => {
        props.close();
      });
    } else {
      MySwal.fire({
        icon: "error",
        title: "Wypełnij",
        text: "wymagane pola formularza",
      }).then(async (result) => {});
    }
  };

  const getData = () => {
    setLoading(false);
  };

  useEffect(() => {
    setLoading(true);
    getData();
  }, []);

  const validate = () => {
    if (!uploadFilesArray.length > 0) {
      return false;
    } else {
      return true;
    }
  };

  const addFiles = (e) => {
    fetchAddFiles();
  };

  return (
    <>
      <div
        style={{
          width: "50vw",
          borderRadius: "15px",
          boxShadow: "-8px 0px 24px 0px rgba(66, 68, 90, 1)",
          position: "fixed",
          right: "0",
          top: "10vh",
          backgroundColor: "white",
          padding: "2%",
          margin: "0px 10px",
          zIndex: "2",
        }}
      >
        {loading ? (
          <Loading />
        ) : (
          <>
            <div style={{ display: "flex", marginBottom: "3vh" }}>
              <div
                style={{
                  width: "85%",
                  textAlign: "left",
                  fontWeight: "600",
                  fontSize: "2vw",
                }}
              >
                DODAJ PLIK
                <br />
                <span style={{ fontSize: ".8vw" }}>
                  Użytkownik: {props.user.name}
                </span>
              </div>
              <div style={{ width: "15%" }}>
                <button
                  className="loginButtonLogin"
                  value="yes"
                  style={{
                    margin: "0",
                    backgroundColor: "navy",
                    borderColor: "navy",
                    width: "100%",
                  }}
                  onClick={props.close}
                >
                  X
                </button>
              </div>
            </div>
            <div style={{ display: "flex", gap: "50px", marginTop: "20px" }}>
              <input
                style={{ border: "none" }}
                multiple={true}
                type="file"
                onChange={changeFiles}
              />
            </div>{" "}
            <div style={{ display: "block", marginTop: "20px", width: "100%" }}>
              <>
                {uploadFilesArray.length > 0 ? (
                  <>
                    <table className="clients_table">
                      <tr>
                        <th style={{ width: "60%" }}>nazwa pliku</th>
                        <th style={{ width: "20%" }}>plik</th>
                        <th style={{ width: "20%" }}>akcja</th>
                      </tr>
                      {uploadFilesArray.map((el, index) => (
                        <>
                          <tr>
                            <td style={{ padding: "10px" }}>
                              <div style={{ display: "flex", gap: "10px" }}>
                                <input
                                  id={"fn" + index}
                                  name={"fn" + index}
                                  style={{
                                    height: "2vh",
                                    marginTop: "0",
                                  }}
                                  type="text"
                                  value={inputs[index]}
                                  onChange={(e) =>
                                    setInputs((prev) => {
                                      return {
                                        ...prev,
                                        [index]: e.target.value,
                                      };
                                    })
                                  }
                                />
                                <button
                                  className="loginButtonLogin"
                                  id={"statusNote"}
                                  style={{
                                    margin: "0",
                                    backgroundColor: "navy",
                                    borderColor: "navy",
                                    fontSize: ".6vw",
                                    padding: "5px 5px",
                                    width: "30%",
                                  }}
                                  value={index}
                                  onClick={changeFileName}
                                >
                                  zmień
                                </button>
                              </div>
                            </td>
                            <td style={{ padding: "10px" }}>{el.name}</td>
                            <td style={{ padding: "10px" }}>
                              <button
                                className="loginButtonLogin"
                                id={"statusNote"}
                                value={index}
                                style={{
                                  margin: "0",
                                  backgroundColor: "navy",
                                  borderColor: "navy",
                                  fontSize: ".6vw",
                                  padding: "5px 5px",
                                  width: "100%",
                                }}
                                onClick={deleteTempFile}
                              >
                                usuń
                              </button>
                            </td>
                          </tr>
                        </>
                      ))}
                    </table>
                    <div style={{ marginTop: "2vh", textAlign: "left" }}>
                      <button
                        className="loginButtonLogin"
                        value="yes"
                        style={{
                          margin: "0",
                          backgroundColor: "green",
                          borderColor: "green",
                        }}
                        onClick={addFiles}
                      >
                        DODAJ PLIKI
                      </button>
                    </div>
                  </>
                ) : (
                  ""
                )}
              </>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default AddFile;
